export var clearFilter = filters => {
  return filters === null || filters === void 0 ? void 0 : filters.map(filterItem => {
    var _a;
    var filter = [];
    filter = (_a = filterItem === null || filterItem === void 0 ? void 0 : filterItem.filterItemValue) === null || _a === void 0 ? void 0 : _a.map(item => {
      item.checked = false;
      return item;
    });
    return Object.assign(Object.assign({}, filterItem), {
      filterItemValue: filter
    });
  });
};
export var getSingleFilterCount = filter => {
  var _a, _b;
  return (_b = (_a = filter === null || filter === void 0 ? void 0 : filter.filterItemValue) === null || _a === void 0 ? void 0 : _a.filter(item => item === null || item === void 0 ? void 0 : item.checked)) === null || _b === void 0 ? void 0 : _b.length;
};
export var getTotalFilterCount = filters => filters === null || filters === void 0 ? void 0 : filters.reduce((a, b) => a + getSingleFilterCount(b), 0);
export var handleFilterCheckbox = (filterItem, selectedFilterItemName) => {
  if ((filterItem === null || filterItem === void 0 ? void 0 : filterItem.name) === selectedFilterItemName) {
    return !(filterItem === null || filterItem === void 0 ? void 0 : filterItem.checked);
  } else return filterItem === null || filterItem === void 0 ? void 0 : filterItem.checked;
};
export var updateFilterItem = (filterItemAr, selectedFilter, type) => {
  return filterItemAr === null || filterItemAr === void 0 ? void 0 : filterItemAr.map(filterItem => {
    filterItem.checked = type === 'single' ? (filterItem === null || filterItem === void 0 ? void 0 : filterItem.name) === selectedFilter.name : handleFilterCheckbox(filterItem, selectedFilter.name);
    return filterItem;
  });
};